"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 10; // in milliseconds

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/delay.js
// module id = kRHc
// module chunks = 57